var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{
  'bg-red': _vm.$root.projectContentsOpen
  },on:{"click":function($event){$event.preventDefault();return _vm.onChapterClick($event)}}},[_c('PlusIcon',{staticClass:"plus-icon",class:{
    'plus-icon--active': _vm.$route.name === 'Chapters'
    }}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$route.name == 'Chapters')?_c('span',[_c('translate',[_vm._v("Close")])],1):_c('span',[_vm._v(_vm._s(_vm.$root.siteSettings.genericChaptersText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }